<div id="container" class="bmw-app-component-body">
  <div id="header" *ngIf="!hideNavbar">
    <app-header></app-header>
  </div>
  <div class="login-navbar" *ngIf='hideNavbar'>
    <div *ngIf='isAdminUser'>
      <h2 style="background: #1c69d4">
        <img src="assets/images/B100_80px_BMW_RGB72DPI.png" alt="Technical Information System" width="60" height="60"
          style="margin-left: 0px"> Technical Information System
      </h2>
    </div>
    <div *ngIf='isBMW && !isAdminUser'>
      <h2 style="background: #1c69d4">
        <img src="assets/images/B100_80px_BMW_RGB72DPI.png" alt="Technical Information System" width="60" height="60"
          style="margin-left: 0px"> Technical Information System
      </h2>
    </div>
    <div *ngIf='isMINI && !isAdminUser'>
      <h2 style="background: #ff0000">
        <img src="assets/images/MINI_symbol_RGB_black_40px.png" alt="Technical Information System" height="60"
          style="margin-left: 0px"> Technical Information System
      </h2>
    </div>
    <div *ngIf='isMOTORRAD && !isAdminUser'>
      <h2 style="background: #1c69d4">
        <img src="assets/images/bmw_motorrad_logo.jpg" alt="Technical Information System" width="60" height="60"
          style="margin-left: 0px"> Technical Information System
      </h2>
    </div>
    <div *ngIf='isRollsRoyce && !isAdminUser'>
      <h2 style="background: #281432">
        <img src="assets/images/RR_logo.png" alt="Technical Information System" width="60" height="55"
          style="margin-left: 0px"> Technical Information System
      </h2>
    </div>
  </div>
  <div id="page">
    <div id="content-wrapper">
      <div class="cms-navbar-wrapper" *ngIf='showAdminNavbar'>
        <app-cms-navbar></app-cms-navbar>
      </div>
      <input type="checkbox" *ngIf=false (change)='toggleAdminNavbar()'>
      <div id="content">
        <app-spinner name="bmwSpinner" [(show)]="showSpinner"></app-spinner>
        <router-outlet></router-outlet>
      </div>
    </div>
    <div *ngIf="showFooter">
      <app-footer></app-footer>
    </div>
  </div>
</div>